const REGIONS = ["India", "USA", "UK", "Canada", "Australia", "Germany", "France", "Japan", "Brazil", "Singapore"];
const PLANS = ["Basic", "Premium", "Enterprise", "Free Trial"];
const STATUSES = ["Active", "Inactive", "Cancelled", "Free Trial"];

const randomItem = (list) => list[Math.floor(Math.random() * list.length)];

const buildRecord = (id, date, region, plan, status, scale = 1) => ({
  id,
  date: date.toISOString().split("T")[0],
  region,
  regionType: region === "India" ? "National" : "International",
  plan,
  status,
  subscribers: Math.floor(Math.random() * (1000 / scale)) + 50 / scale,
  revenue: status === "Free Trial" ? 0 : Math.floor(Math.random() * (50000 / scale)) + 1000 / scale,
  revenueINR:
    status === "Free Trial" ? 0 : region === "India" ? (Math.floor(Math.random() * (50000 / scale)) + 1000 / scale) * 83 : 0,
  revenueUSD:
    status === "Free Trial" ? 0 : region !== "India" ? Math.floor(Math.random() * (50000 / scale)) + 1000 / scale : 0,
  freeTrialUsers: plan === "Free Trial" || status === "Free Trial" ? Math.floor(Math.random() * (200 / scale)) + 10 / scale : 0,
  cancelledRecurring: status === "Cancelled" ? Math.floor(Math.random() * (100 / scale)) + 5 / scale : 0,
  month: date.toLocaleDateString("en-US", { month: "short", year: "numeric" }),
  week: `W${Math.ceil(date.getDate() / 7)}-${date.toLocaleDateString("en-US", { month: "short" })}`,
  year: date.getFullYear().toString(),
});

export const generateSubscriberData = () => {
  const data = [];
  const startDate = new Date("2023-01-01");
  const endDate = new Date("2024-12-31");

  for (let i = 0; i < 1200; i += 1) {
    const date = new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime()));
    data.push(buildRecord(i + 1, date, randomItem(REGIONS), randomItem(PLANS), randomItem(STATUSES)));
  }

  const dailyData = [];
  const currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    const dateStr = currentDate.toISOString().split("T")[0];
    if (!data.some((item) => item.date === dateStr)) {
      dailyData.push(
        buildRecord(
          data.length + dailyData.length + 1,
          new Date(currentDate),
          randomItem(REGIONS),
          randomItem(PLANS),
          randomItem(STATUSES),
          2
        )
      );
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return [...data, ...dailyData];
};

const matchesFilters = (item, filters) => {
  const itemDate = new Date(item.date);
  return (
    (filters.regionType === "All" || item.regionType === filters.regionType) &&
    (filters.plan === "All" || item.plan === filters.plan) &&
    (filters.status === "All" || item.status === filters.status) &&
    itemDate >= new Date(filters.startDate) &&
    itemDate <= new Date(filters.endDate)
  );
};

export const groupAnalyticsData = (data, filters) => {
  const grouped = data.filter((item) => matchesFilters(item, filters)).reduce((acc, item) => {
    const key =
      filters.groupBy === "day"
        ? item.date
        : filters.groupBy === "week"
        ? item.week
        : filters.groupBy === "year"
        ? item.year
        : item.month;

    if (!acc[key]) {
      acc[key] = {
        period: key,
        totalSubscribers: 0,
        totalRevenue: 0,
        totalRevenueINR: 0,
        totalRevenueUSD: 0,
        freeTrialUsers: 0,
        cancelledRecurring: 0,
        nationalSubscribers: 0,
        internationalSubscribers: 0,
      };
    }

    acc[key].totalSubscribers += item.subscribers;
    acc[key].totalRevenue += item.revenue;
    acc[key].totalRevenueINR += item.revenueINR;
    acc[key].totalRevenueUSD += item.revenueUSD;
    acc[key].freeTrialUsers += item.freeTrialUsers;
    acc[key].cancelledRecurring += item.cancelledRecurring;
    if (item.regionType === "National") {
      acc[key].nationalSubscribers += item.subscribers;
    } else {
      acc[key].internationalSubscribers += item.subscribers;
    }
    return acc;
  }, {});

  return Object.values(grouped).sort((a, b) => a.period.localeCompare(b.period));
};

export const summarizeAnalyticsData = (data, filters) => {
  const filteredData = data.filter((item) => matchesFilters(item, filters));
  const nationalData = filteredData.filter((item) => item.regionType === "National");
  const internationalData = filteredData.filter((item) => item.regionType === "International");
  return {
    total: filteredData.reduce((sum, item) => sum + item.subscribers, 0),
    national: nationalData.reduce((sum, item) => sum + item.subscribers, 0),
    international: internationalData.reduce((sum, item) => sum + item.subscribers, 0),
    totalRevenueINR: filteredData.reduce((sum, item) => sum + item.revenueINR, 0),
    totalRevenueUSD: filteredData.reduce((sum, item) => sum + item.revenueUSD, 0),
    freeTrialUsers: filteredData.reduce((sum, item) => sum + item.freeTrialUsers, 0),
    cancelledRecurring: filteredData.reduce((sum, item) => sum + item.cancelledRecurring, 0),
  };
};

export const getPlanDistribution = (data, filters) => {
  const planCounts = data
    .filter((item) => {
      const itemDate = new Date(item.date);
      return (
        (filters.regionType === "All" || item.regionType === filters.regionType) &&
        itemDate >= new Date(filters.startDate) &&
        itemDate <= new Date(filters.endDate)
      );
    })
    .reduce((acc, item) => {
      acc[item.plan] = (acc[item.plan] || 0) + item.subscribers;
      return acc;
    }, {});

  return Object.entries(planCounts).map(([name, value]) => ({ name, value }));
};
